import type { BudgetTranslations } from "../../types/budget";

export const budget: BudgetTranslations = {
  title: "Eelarve",
  manageBudgetFor: "Halda eelarvet hoone {buildingName} jaoks",
  distribution: "Eelarve jaotus",
  monthlyForecast: "12 kuu prognoos",
  details: "Eelarve \u00FCksikasjad",
  tabs: {
    distribution: "Jaotus",
    overview: "\u00DClevaade",
    costs: "Kulud",
    payments: "Maksed",
    forecasts: "Prognoosid",
  },
  metrics: {
    netAreaTooltip: "Hoone kasutatav p\u00F5randapind",
    addAreaData: "Lisa hoone pindala andmed",
    costPerM2Tooltip: "Kogueelarve jagatud netopinnaga",
    costPerM2Range: "T\u00FC\u00FCpiline vahemik: \u20AC1 500\u2013\u20AC3 000/m\u00B2",
    addBudgetData: "Lisa eelarve andmed arvutamiseks",
    belowAverage: "Alla keskmise kulu",
    aboveAverage: "\u00DCle keskmise kulu",
    withinRange: "T\u00FC\u00FCpilises vahemikus",
    complete: "Valmis",
    areaSetAddBudget: "Pindala m\u00E4\u00E4ratud, lisa eelarve",
    missingData: "Puuduvad pindala ja eelarve andmed",
    totalBudgetTooltip: "K\u00F5igi eelarvekategooriate summa",
    includesAllItems: "Sisaldab k\u00F5iki kuluartikleid",
    noBudgetItems: "\u00DCtegi eelarve rida pole veel lisatud",
  },
  costs: {
    newSubcategory: "Uus alamkategooria",
    total: "Kokku: {amount}",
    name: "Nimi",
    value: "V\u00E4\u00E4rtus",
    general: "\u00DCldine",
    categories: {
      preparationCosts: "Ettevalmistuskulud",
      siteInvestigation: "Pinnase uuringud",
      designFees: "Projekteerimistasud",
      permits: "Load",
      externalStructures: "V\u00E4liskonstruktsioonid",
      landscaping: "Haljastus",
      parkingAreas: "Parkimisalad",
      fencing: "Piirded",
      foundation: "Vundament",
      excavation: "Kaevet\u00F6\u00F6d",
      concreteWork: "Betoonit\u00F6\u00F6d",
      waterproofing: "H\u00FCdroisolatsioon",
      loadBearingStructures: "Kandvad konstruktsioonid",
      steelFramework: "Teraskarkass",
      concreteColumns: "Betoonpostid",
      floorSlabs: "P\u00F5randaplaadid",
      facadeAndRoofing: "Fassaadielemendid ja katusekate",
      externalWalls: "V\u00E4lisseinad",
      windows: "Aknad",
      roofingMaterials: "Katusematerjalid",
      interiorWallsCeilings: "Siseseinad ja laed",
      partitionWalls: "Vaheseina",
      ceilingSystems: "Laes\u00FCsteemid",
      wallFinishes: "Seinaviimistlus",
      fixturesEquipment: "Sisseseade ja varustus",
      bathroomFixtures: "Vannitoa sisustus",
      kitchenEquipment: "K\u00F6\u00F6giseadmed",
      builtInFurniture: "Sisseehitatud m\u00F6\u00F6bel",
      technicalSystems: "Tehnilised s\u00FCsteemid",
      hvac: "K\u00FCte, ventilatsioon ja jahutus",
      electrical: "Elektris\u00FCsteemid",
      plumbing: "Torustik",
      siteMaintenanceCosts: "Ehitusplatsi hooldus",
      siteSecurity: "Objekti turvalisus",
      temporaryFacilities: "Ajutised rajatised",
      wasteManagement: "J\u00E4\u00E4tmek\u00E4itlus",
      siteOverheads: "Ehitusplatsi \u00FCldkulud",
      projectManagement: "Projektijuhtimine",
      siteSupervision: "Ehitusj\u00E4relevalve",
      insurance: "Kindlustus",
      coverageRiskGrowth: "Katvus, risk, kasv",
      contingency: "Reserv",
      insuranceCoverage: "Kindlustuskatvus",
      growthMargin: "Kasvumarginal",
    },
  },
  payments: {
    completionPercentages: "Valmidusastmed",
    savedSuccessfully: "Valmidusastmed edukalt salvestatud",
    saveFailed: "Valmidusastmete salvestamine eba\u00F5nnestus",
    summary: "Maksete kokkuv\u00F5te",
    totalBudget: "Kogueelarve:",
    completedValue: "Teostatud v\u00E4\u00E4rtus:",
    previouslyPaid: "Eelnevalt makstud:",
    currentPayment: "Jooksev makse:",
    actGenerated: "Makseakt genereeritud",
    downloadedSuccessfully: "Teie makseakt on edukalt alla laaditud.",
    generateError: "Makseakti genereerimine eba\u00F5nnestus",
    generating: "Genereerimine...",
    generateAct: "Genereeri akt",
    lastSaved: "Viimati salvestatud: {time}",
    loadFailed: "Maksete andmete laadimine eba\u00F5nnestus",
    savePaymentsFailed: "Maksete salvestamine eba\u00F5nnestus",
    noBudgetDataFound: "Eelarve andmeid ei leitud",
  },
};
